import { SelectOption } from '../SelectOption';

export enum BatchSnapshotStatusEnum {
    Created = 1,
    InProgress,
    Failed,
    Cancelled,
    Completed
}

export enum BatchSnapshotStatusNameEnum {
    Created = 'Created',
    InProgress = 'In Progress',
    Failed = 'Failed',
    Cancelled = 'Cancelled',
    Completed = 'Completed'
  }

export const BatchSnapshotStatuses: SelectOption[] = [
    { value: BatchSnapshotStatusEnum.Created, text: BatchSnapshotStatusNameEnum.Created },
    { value: BatchSnapshotStatusEnum.InProgress, text: BatchSnapshotStatusNameEnum.InProgress },
    { value: BatchSnapshotStatusEnum.Failed, text: BatchSnapshotStatusNameEnum.Failed },
    { value: BatchSnapshotStatusEnum.Cancelled, text: BatchSnapshotStatusNameEnum.Cancelled },
    { value: BatchSnapshotStatusEnum.Completed, text: BatchSnapshotStatusNameEnum.Completed }
];
